import {IEvent} from "../data/interfaces";
import {CALENDAR_EVENT_SYMBOLS} from "./calendarEventSymbols";
import {shouldShowShipOnlyMarker} from "./shipOnlyUtils";


/**
 * Builds the event title based on the IEvent object.
 * @param event - The event object containing crew, traveler, custom text, and other event properties.
 * @returns The constructed title for the event.
 */
export function buildEventTitle(event: IEvent): string {
  let titleIcons: string[] = [];

  // Add icons based on crew
  switch (event.eventType) {
    case 'Holiday':
      titleIcons.push(CALENDAR_EVENT_SYMBOLS.holiday);
      break;
    case 'Day Off':
      titleIcons.push(CALENDAR_EVENT_SYMBOLS.dayOff);
      break;
    case 'Team Meeting':
      titleIcons.push(CALENDAR_EVENT_SYMBOLS.teamMeeting);
      break;
    case 'No PO (pending)':
      titleIcons.push(CALENDAR_EVENT_SYMBOLS.pendingCustomerPo);
      break;
    default:
      // no special icons for other event types
      break;
  }

  if (event.notes) {
    titleIcons.push(CALENDAR_EVENT_SYMBOLS.notes);
  }

  if (shouldShowShipOnlyMarker(event.department, event.traveler)) {
    titleIcons.push(CALENDAR_EVENT_SYMBOLS.shipOnly);
  }

  let titleParts: string[] = [];

  // Add traveler display name
  if (event.traveler) {
    titleParts.push(event.traveler.displayName);
  }

  // Add custom text if available
  if (event.customText) {
    titleParts.push(event.customText);
  }

  // Join icons and parts to create the final title
  const title = `${titleIcons.join("")} ${titleParts.join(" - ")}`.trim();
  return title.length > 0 ? title : "(untitled)";
}
